import Vue from 'vue';
import axios from "axios";
import VueAxios from "vue-axios";
import store from '../store';

export const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API
})

function getTokenFromPersistedState() {
    try {
        const rawState = window.localStorage.getItem('@SysRcpSe43e');
        if (!rawState) return null;
        const persistedState = JSON.parse(rawState);
        return persistedState?.auth?.token || null;
    } catch (err) {
        return null;
    }
}

const mensagensLogout = [
    '[Controller-Erro]: Credencial não informada!',
    '[Controller-Erro]: Sua sessão expirou, efetue o login novamente!'
]

axiosInstance.interceptors.response.use(
    async (response) => {
        await store.restored;

        if(!response.data.success && mensagensLogout.indexOf(response.data.msg) > -1) {
            await store.dispatch('auth/doLogout');
            return response;
        }

        if(response.data.token != null && response.data.token !== '') {
            store.commit("auth/SET_TOKEN", response.data.token);
        }

        return response;
    },
)

axiosInstance.interceptors.request.use(
    async request => {
        await store.restored;
        const authToken = store.getters["auth/token"] || getTokenFromPersistedState();
        const hasTokenOnUrl = typeof request.url === 'string' && /[?&]tk=/.test(request.url);
        if(authToken && !hasTokenOnUrl) {
            //request.headers.Authorization = `Bearer ${authToken}`;
            request.url += `${request.url.indexOf('?') === -1 ? '?' : '&'}tk=${encodeURIComponent(authToken)}`;
            //console.log(request.url);
        }

        return request;
    }
)

Vue.use(VueAxios, axiosInstance);